import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=d688f186&"
import script from "./ChatLayout.vue?vue&type=script&lang=js&"
export * from "./ChatLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports